export default __webpack_public_path__ + "static/media/OTP.e9633564.svg";